// extracted by mini-css-extract-plugin
export default {"headers":"headers_headers__EvWBo","headersContainer":"headers_headersContainer__8TugL","title":"headers_title__Uw6tQ","headerLinks":"headers_headerLinks__y3Tj6"};